import { IAppState } from '../../store';

export const selectDeviceType = (state: IAppState) => state.pageData.deviceType;
